import { SvgIcon } from '../styled-components';
import { SvgIconProps } from '@material-ui/core/SvgIcon';

const CaseIcon: React.FC<SvgIconProps> = ({
  viewBox = '0 0 69.738 63.553',
  ...rest
}) => (
  <SvgIcon
    {...rest}
    viewBox={viewBox}
    style={{ width: 69.738, height: 63.553 }}
  >
    <g
      xmlns="http://www.w3.org/2000/svg"
      transform="translate(-176.399 -21.737)"
    >
      <circle
        fill="none"
        stroke="#224060"
        strokeMiterlimit="10"
        strokeWidth="2px"
        cx="2.987"
        cy="2.987"
        r="2.987"
        transform="translate(177.399 78.317)"
      />
      <circle
        fill="none"
        stroke="#224060"
        strokeMiterlimit="10"
        strokeWidth="2px"
        cx="2.987"
        cy="2.987"
        r="2.987"
        transform="translate(218.575 78.317)"
      />
      <circle
        fill="none"
        stroke="#224060"
        strokeMiterlimit="10"
        strokeWidth="2px"
        cx="2.987"
        cy="2.987"
        r="2.987"
        transform="translate(239.163 78.317)"
      />
      <circle
        fill="#224060"
        stroke="#224060"
        strokeMiterlimit="10"
        strokeWidth="2px"
        cx="2.987"
        cy="2.987"
        r="2.987"
        transform="translate(197.987 78.317)"
      />
      <line
        fill="none"
        stroke="#224060"
        strokeMiterlimit="10"
        strokeWidth="2px"
        x2="14.615"
        transform="translate(183.372 81.304)"
      />
      <line
        fill="none"
        stroke="#224060"
        strokeMiterlimit="10"
        strokeWidth="2px"
        x2="14.601"
        transform="translate(204.322 81.304)"
      />
      <line
        fill="none"
        stroke="#224060"
        strokeMiterlimit="10"
        strokeWidth="2px"
        x2="14.601"
        transform="translate(224.571 81.304)"
      />
      <path
        fill="none"
        stroke="#224060"
        strokeMiterlimit="10"
        strokeWidth="2px"
        d="M223.495,44.311l-4.422-1.685,2.151-5.643,4.422,1.685a6.288,6.288,0,1,0-12.06,3.206l-13.4,13.2,5.365,4.833,11.583-14.519c.014.005.027.013.041.018A6.287,6.287,0,0,0,223.495,44.311Z"
      />
      <path
        fill="none"
        stroke="#224060"
        strokeMiterlimit="10"
        strokeWidth="2px"
        d="M213.722,22.737A22.928,22.928,0,0,0,194.3,57.863L189.175,70.4l12.6-5.153a22.933,22.933,0,1,0,11.95-42.508Z"
      />
    </g>
  </SvgIcon>
);

export default CaseIcon;
